export default __webpack_public_path__ + "static/media/94 cents .474d8812.jpg";